<template>
  <div class="home">
    <div class="header">
      <div class="wrapper">
        <div class="row">
          <div class="col-md-8">
            <h2 class="title-text">StokerCloud</h2>
          </div>
          <div class="col-md-4">
            <div class="search-field white--text">
              <v-text-field
                dark
                color="#fff"
                label="Type username/serial"
                :value="searchText"
                append-icon="search"
                :loading="fieldLoading"
                @input="searchField"
                v-on:keyup.enter="handleSubmit"
              ></v-text-field>
            </div>
            <!-- <div v-if="showSearchResults && searchResults.length">
              <div class="search-result">
                <ul v-for="(item, index) in searchResults" :key="item + index">
                  <li @click="itemClick(item[index])">{{item[index]}}</li>
                </ul>
              </div>
              <div class="search-result-bg" @click="showSearchResults = false"></div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="map-container">
      <!-- <div id="map"></div> -->
      <!-- <map-view 
        :markers="markers"
        @markerClick="markerClick($event)"
      >
      </map-view> -->

      <v-img
        :src="require('../assets/static-map.png')"
        class="full-screen"
        alt="Description"
      ></v-img>

      <!-- <div v-else style="width: 100%; height: 400px">
        <loading></loading>
      </div> -->
      <!-- <div class="wrapper">
        <div class="py-5" v-if="userTables.tables">
          <div class="row">
            <div class="col-md-3" v-if="userTables.tables.smoke">
              <table-data
                :userData="userTables.tables.smoke"
                column-one="Username"
                units="Smoke temperature °C"
                title="Top 10 smoke right now"
                @itemClick="itemClick"
              />
            </div>
            <div class="col-md-3" v-if="userTables.tables.consumptionhigh">
              <table-data
                :userData="userTables.tables.consumptionhigh"
                column-one="Username"
                units="Kg pills/m2/day"
                title="Top 10 consumption/m2"
                @itemClick="itemClick"
              />
            </div>
            <div class="col-md-3" v-if="userTables.tables.consumptionlow">
              <table-data
                :userData="userTables.tables.consumptionlow"
                column-one="Username"
                units="Kg pills/m2/day"
                title="Bottom 10 consumption/m2"
                @itemClick="itemClick"
              />
            </div>
            <div class="col-md-3" v-if="userTables.tables.ignitions">
              <table-data
                :userData="userTables.tables.ignitions"
                column-one="Username"
                units="# ignitions"
                title="Top 10 ignitions last 24 hours"
                @itemClick="itemClick"
              />
            </div>
          </div>
        </div>
        <loading v-if="getLoading"></loading>
      </div> -->
    </div>
    <center class="footer">
      <!-- <br />
      <a
        href="https://www.positivessl.com"
        style="font-family: arial; font-size: 10px; color: #212121; text-decoration: none;"
      >
        <img
          src="https://www.positivessl.com/images-new/PositiveSSL_tl_trans2.gif"
          alt="SSL Certificate"
          title="SSL Certificate"
          border="0"
        />
      </a>
      <br /> -->
      <!-- <a href="http://nbe.dk">nbe.dk</a> |
      <a href="http://nbe-global.com">nbe-global.com</a> -->
      <span>NBE Production A/S - Kjeldgaardsvej 2 - 9300 Sæby - Denmark</span>
    </center>
    <user-info-window
      :openDialog="userInfoToggle"
      :closeDialog="closeInfoDialog"
      :userId="selectedUserId"
    ></user-info-window>
  </div>
</template>

<script>
// @ is an alias to /src
import GlobalService from '../services/global-service';
import Loading from '../components/Loading';
import TableData from '../components/TableData';
import UserInfoWindow from '../components/UserInfoWindow';
import MapView from '../components/MapView';

export default {
  name: 'home',
  components: {
    Loading,
    TableData,
    UserInfoWindow,
    MapView,
  },
  data: () => ({
    userTables: {},
    getLoading: false,
    markersData: [],
    markers: [],
    userInfoToggle: false,
    selectedUserId: '',
    fieldLoading: false,
    searchResults: [],
    showSearchResults: false,
    searchText: '',
  }),
  mounted() {
    // google.maps.event.addDomListener(window, "load", this.initialize);
  },
  async created() {
    this.FetchApisData();
    this.getLoading = true;
    this.userTables = await GlobalService.getUserTables();
    this.getLoading = false;
  },
  methods: {
    async FetchApisData() {
      this.markersData = await GlobalService.getUserLocations();
      // for (let i = 0; i < this.markersData.length; i++) {
      //   let marker = {
      //     lat: Number(this.markersData[i].lat),
      //     lng: Number(this.markersData[i].lng),
      //     userId: this.markersData[i].userid,
      //     alias: this.markersData[i].alias
      //   };
      //   this.markers.push(marker);
      // }
      if (this.markersData.length) {
        this.markers = this.markersData;
      }
    },
    markerClick(mark) {
      // console.log("marker: ", mark);
      this.userInfoToggle = true;
      this.selectedUserId = mark.userid;
    },
    closeInfoDialog() {
      this.userInfoToggle = false;
      // this.selectedUserId = "";
    },
    async searchField(val) {
      if (val.length >= 3) {
        this.fieldLoading = true;
        this.searchResults = await GlobalService.searchUsers(val);
        this.showSearchResults = true;
        this.fieldLoading = false;
      } else {
        this.showSearchResults = false;
      }
    },
    itemClick(val) {
      window.location = `https://stokercloud.dk/dev/${val}.html`;
      // this.searchText = val;
      // this.showSearchResults = false;
    },
    initialize() {
      var center = new google.maps.LatLng(
        48.66583749999999,
        18.258985199999984,
      );

      var map = new google.maps.Map(document.getElementById('map'), {
        zoom: 3,
        center: center,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      });

      var markers = [];
      for (var i = 0; i < this.markersData.length; i++) {
        var dataPhoto = this.markersData[i];
        var latLng = new google.maps.LatLng(dataPhoto.lat, dataPhoto.lng);
        var marker = new google.maps.Marker({
          position: latLng,
        });
        markers.push(marker);
      }
      var mcOptions = {
        //imagePath: 'https://googlemaps.github.io/js-marker-clusterer/images/m',
        styles: [
          {
            url:
              'https://googlemaps.github.io/js-marker-clusterer/images/m1.png',
            width: 53,
            height: 53,
            fontFamily: 'comic sans ms',
            textSize: 15,
            textColor: 'red',
            //color: #00FF00,
          },
        ],
      };
      var markerCluster = new MarkerClusterer(map, markers, mcOptions);

      // let marker = new google.maps.Marker({
      //   map: map,
      //   draggable: true,
      //   animation: google.maps.Animation.DROP,
      //   position: { lat: 59.327, lng: 18.067 }
      // });
      // marker.addListener("click", this.toggleBounce);
    },
    handleSubmit() {
      if (this.searchResults.length) {
        window.location = `https://stokercloud.dk/dev/${
          this.searchResults[0][0]
        }.html`;
      }
    },
  },
};
</script>
<style scoped>
.search-result {
  background-color: #fff;
  padding: 10px;
  position: absolute;
  left: 15px;
  right: 15px;
  top: 50px;
  max-height: 400px;
  overflow-y: auto;
  z-index: 5555;
}
.search-result ul {
  margin: 0;
  padding: 0;
  text-align: left;
  cursor: pointer;
}
.search-result ul a {
  color: #000;
  text-decoration: none !important;
}
.search-result ul li {
  padding: 10px;
  list-style: none;
}
.search-result ul li:hover {
  background-color: #b5cfd2;
  color: #333;
}
.search-result-bg {
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 55;
}
.title-text {
  text-align: left;
}
.full-screen {
  width: 100vw;
  height: 80vh;
  object-fit: cover;
}
</style>
